"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var FontSizePipe = (function () {
    function FontSizePipe() {
    }
    FontSizePipe.prototype.transform = function (value) {
        return parseInt(value.replace(/[^-\d\.]/g, '') || '16');
    };
    FontSizePipe = __decorate([
        core_1.Pipe({
            name: 'FontSize',
            pure: true
        }), 
        __metadata('design:paramtypes', [])
    ], FontSizePipe);
    return FontSizePipe;
}());
exports.FontSizePipe = FontSizePipe;
var FontStylesPipe = (function () {
    function FontStylesPipe() {
    }
    FontStylesPipe.prototype.transform = function (value) {
        var lookup = {
            '100': 'Thin',
            '200': 'Extra-Light',
            '300': 'Light',
            '400': 'Regular',
            '500': 'Medium',
            '600': 'Semi-bold',
            '700': 'Bold',
            '800': 'Extra-bold',
            '900': 'Black'
        };
        for (var style in lookup) {
            var found = value.search(style);
            if (found >= 0) {
                value = value.replace(style, lookup[style] + ' ');
                break;
            }
        }
        return value;
    };
    FontStylesPipe = __decorate([
        core_1.Pipe({
            name: 'FontStyles',
            pure: true
        }), 
        __metadata('design:paramtypes', [])
    ], FontStylesPipe);
    return FontStylesPipe;
}());
exports.FontStylesPipe = FontStylesPipe;
var StatefulSlicePipe = (function () {
    function StatefulSlicePipe() {
        this.slicedArray = [];
        this.previousArrayRef = [];
        this.previousEndValue = null;
    }
    StatefulSlicePipe.prototype.transform = function (arr, start, end) {
        if (arr && (this.previousEndValue != end || this.previousArrayRef !== arr)) {
            this.slicedArray = arr.slice(start, end);
            this.previousArrayRef = arr;
            this.previousEndValue = end;
        }
        return this.slicedArray || arr;
    };
    StatefulSlicePipe = __decorate([
        core_1.Pipe({
            name: 'StatefulSlice',
            pure: false
        }), 
        __metadata('design:paramtypes', [])
    ], StatefulSlicePipe);
    return StatefulSlicePipe;
}());
exports.StatefulSlicePipe = StatefulSlicePipe;



//////////////////
// WEBPACK FOOTER
// ./src/lib/pipes.ts
// module id = 16
// module chunks = 0 1